import { AxiosError } from 'axios'
import { redirectTo } from '../redirectBus'

export const errorHandlerAuth = (error: AxiosError) => {
  redirectTo.address = '/login/auth-error'

  return Promise.reject(error)
}
